import React from 'react';
import { Button } from '@mui/material';

interface SteamLoginButtonProps {
  onLoginSuccess: (user: any) => void;
  redirectPath: string;
}

const SteamLoginButton: React.FC<SteamLoginButtonProps> = ({ onLoginSuccess, redirectPath }) => {
  const handleSteamLogin = () => {
    const steamUrl = `${process.env.REACT_APP_API_URL}/auth/steam/login?redirect_uri=${encodeURIComponent(
      `${process.env.REACT_APP_FRONTEND_URL}/auth/steam/callback?mode=login`
    )}`;
    
    window.location.href = steamUrl;
  };

  return (
    <Button
        variant="outlined"
        onClick={handleSteamLogin}
        startIcon={
          <img 
            src="/icons/service/source/steam_.svg" 
            alt="Steam" 
            style={{ width: '20px', height: '20px', filter: 'invert(1)' }}
          />
        }
        fullWidth
        sx={{
          borderColor: 'rgba(255, 255, 255, 0.12)',
          color: 'text.primary',
          background: 'linear-gradient(135deg, rgba(27, 40, 56, 0.1), rgba(47, 138, 190, 0.1))',
          '&:hover': {
            borderColor: 'rgba(255, 255, 255, 0.2)',
            background: 'linear-gradient(135deg, rgba(27, 40, 56, 0.15), rgba(47, 138, 190, 0.15))'
          },
          textTransform: 'none',
          fontWeight: 500,
          py: 0.75,
          backdropFilter: 'blur(8px)',
          transition: 'all 0.2s ease',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(27, 40, 56, 0.4), rgba(47, 138, 190, 0.4))',
            zIndex: -1
          }
        }}
      >
        Steamでログイン
      </Button>
  );
};

export default SteamLoginButton;
